import { useState } from "react";
import { faqs, trustList } from "@/mocks/jiukanliao";

export default function FaqSection() {
  const [active, setActive] = useState<number>(0);

  return (
    <section id="faq" className="bg-[#fff9f0] py-14 md:py-20">
      <div className="mx-auto max-w-[1200px] px-4 md:px-8">
        <div className="text-center">
          <span className="inline-flex items-center gap-2 rounded-full border border-[#eccf9d] bg-[#fff6e6] px-3 py-1 text-xs font-semibold tracking-[0.15em] text-[#a86a1f]">
            <i className="ri-shield-check-line" />
            信任与浏览须知
          </span>
          <h2 className="font-display mt-4 text-3xl font-black text-[#231f18] md:text-4xl">
            看得明白，也看得安心
          </h2>
        </div>

        {/* 信任卡片组 */}
        <div className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-3">
          {trustList.map((t) => (
            <div
              key={t.title}
              className="rounded-2xl border border-[#eadbc0] bg-white p-5 md:p-6"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-[#fff1e2] text-lg text-[#d9431f]">
                <i className={t.icon} />
              </span>
              <h3 className="font-display mt-4 text-base font-bold text-[#231f18]">
                {t.title}
              </h3>
              <p className="mt-2 text-[13px] leading-6 text-[#6b5f48]">{t.desc}</p>
            </div>
          ))}
        </div>

        {/* FAQ 手风琴 */}
        <div className="mt-12 grid grid-cols-1 gap-8 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <h3 className="font-display text-xl font-black text-[#231f18]">
              常见问题，
              <br />
              一次讲清
            </h3>
            <p className="mt-3 text-[13px] leading-6 text-[#8a7a5d]">
              关于九宫格、九图吃瓜、多图预警与截图可信度，点开对应条目即可查看回答。
            </p>
            <div className="mt-5 flex items-center gap-3 rounded-2xl bg-[#fff1e2] p-4">
              <i className="ri-lightbulb-flash-line text-2xl text-[#d9431f]" />
              <p className="text-[13px] leading-6 text-[#7a4a2c]">
                理性围观、友善发言，9看料 希望你每一次看图都轻松又安心。
              </p>
            </div>
          </div>

          <div className="flex flex-col gap-3 lg:col-span-8">
            {faqs.map((f, i) => {
              const isOpen = active === i;
              return (
                <div
                  key={f.q}
                  className={`overflow-hidden rounded-2xl border bg-white transition ${
                    isOpen ? "border-[#d9b67a]" : "border-[#eadbc0]"
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setActive(isOpen ? -1 : i)}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <span className="flex items-center gap-3 text-[15px] font-semibold text-[#231f18]">
                      <span
                        className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs font-bold ${
                          isOpen ? "bg-[#d9431f] text-white" : "bg-[#fff1e2] text-[#d9431f]"
                        }`}
                      >
                        {String(i + 1).padStart(2, "0")}
                      </span>
                      {f.q}
                    </span>
                    <i
                      className={`ri-add-line shrink-0 text-lg text-[#b43a17] transition-transform duration-300 ${
                        isOpen ? "rotate-45" : ""
                      }`}
                    />
                  </button>
                  <div
                    className={`grid transition-all duration-300 ${
                      isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                    }`}
                  >
                    <div className="overflow-hidden">
                      <p className="px-5 pb-5 pl-14 text-[14px] leading-7 text-[#6b5f48]">
                        {f.a}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}